/** @type {import("tailwindcss").Config} */

export default {
  theme: {
    fontFamily: {
      // sans: ["Raleway", "sans-serif"],
      sans: [
        "cairo",
        "ui-sans-serif",
        "system-ui",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Roboto",
        "Helvetica Neue",
        "Arial",
        "Noto Sans",
        "sans-serif",
        "Apple Color Emoji",
        "Segoe UI Emoji",
        "Segoe UI Symbol",
        "Noto Color Emoji",
      ],
      "demo-chrono": [
        "Roboto",
        "Helvetica Neue",
        "Arial",
        "Noto Sans",
        "sans-serif",
        "Apple Color Emoji",
        "Segoe UI Emoji",
        "Segoe UI Symbol",
        "Noto Color Emoji",
      ],
      "eni-title": ["Spinnaker", "Helvetica", "Arial", "Lucida", "sans-serif"],
      "eni-base": ["Open Sans", "Helvetica", "Arial", "Lucida", "sans-serif"],
      "fdm-title": ["Anton", "Helvetica", "Arial", "Lucida", "sans-serif"],
      lnc: ["Source Sans 3", "Lato", "Bebas Neue", "Arial", "Verdana"],
      "st-james-title": ["DM Serif Display", "Lato", "Roboto", "Helvetica Neue", "Arial", "Noto Sans", "sans-serif"],
      "st-james-base": ["Lato", "Roboto", "Helvetica Neue", "Arial", "Noto Sans", "sans-serif"],
      velodrome: ["Montserrat", "Roboto", "Helvetica", "Arial", "Lucida", "sans-serif"],
    },
    extend: {
      backgroundImage: (theme) => ({
        bib: "url('dossard-ikinoa.png')",
      }),
      colors: {
        primary: "var(--color-primary)",
        "primary-light": "var(--color-primary-light)",
        "primary-darker": "var(--color-primary-darker)",
        "primary-lighter": "var(--color-primary-lighter)",
        "primary-max-light": "var(--color-primary-max-light)",
        secondary: "var(--color-secondary)",
        "secondary-1": "var(--color-secondary-1)",
        "secondary-2": "var(--color-secondary-2)",
        "secondary-3": "var(--color-secondary-3)",
        "secondary-4": "var(--color-secondary-4)",
        "secondary-5": "var(--color-secondary-5)",
        "secondary-6": "var(--color-secondary-6)",
        warning: "var(--warning)",
      },
      borderRadius: {
        common: "var(--common-border-radius)",
      },
      keyframes: {
        "slide-in-up": {
          from: {
            transform: "translate3d(0, 100%, 0)",
            visibility: "visible",
          },
          to: {
            transform: "translate3d(0, 0, 0)",
          },
        },
        "slide-out-down": {
          from: {
            transform: "translate3d(0, 0, 0)",
          },
          to: {
            visibility: "hidden",
            transform: "translate3d(0, 100%, 0)",
          },
        },
      },
      animation: {
        "slide-in-up": "slide-in-up 0.5s ease-in-out",
        "slide-out-down": "slide-out-down 0.5s ease-in-out",
      },
    },
  },
  content: [
    "./app/views/**/*.html.slim",
    "./app/helpers/**/*.rb",
    "./app/assets/stylesheets/**/*.css",
    "./app/javascript/**/*.{ts,js}",
    "./config/**/*.yml",
    "./config/**/*.rb",
    "/var/www/ikinoa_white_label/app/views/**/*.html.slim",
    "/var/www/ikinoa_white_label/app/assets/stylesheets/ikinoa_white_label/**/*.css",
    // "../ikinoa_white_label/app/views/**/*.html.slim",
    // "../ikinoa_white_label/app/assets/stylesheets/ikinoa_white_label/**/*.css",
  ],
  plugins: [import("@tailwindcss/forms")],
  safelist: [
    { pattern: /^(bg|text|border|border-t|border-r|border-b|border-l|fill)-secondary(-\d+)?$/ },
    { pattern: /^((sm|md|lg|xl):)?text-(left|right)?$/ },
    { pattern: /^((sm|md|lg|xl):)?m(t|b|l|r)?-\d{1,2}$/ },
  ],
};
